import {
  reactQueryPost,
  reactQueryPut,
} from "../helpers/backendRequestHelpers";
import { connections } from "../helpers/urlHelpers/internalApi/connections";

export interface CreateConnectionParams {
  memberId: number;
}

const createConnection = (params: CreateConnectionParams) =>
  reactQueryPost(connections.create(), {
    recipient_id: params.memberId,
  });

const acceptConnection = (connectionId: string) =>
  reactQueryPut(connections.accept(connectionId));

const ignoreConnection = (connectionId: string) =>
  reactQueryPut(connections.ignore(connectionId));

const withdrawConnection = (connectionId: string) =>
  reactQueryPut(connections.withdraw(connectionId));

export const connectionsApi = {
  createConnection,
  acceptConnection,
  ignoreConnection,
  withdrawConnection,
};
